import React from "react";
import { Box, Typography, Card } from "@mui/material";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import {
  containerSx,
  titleSx,
  captionSx,
  getScrollBoxSx,
  getPharmacyCardSx,
  cardInnerBoxSx,
  getPharmacyIconSx,
  pharmacyNameSx,
  pharmacyTextBoxSx,
  pharmacyAddressSx,
} from "./styles";

interface Pharmacy {
  id: number;
  name: string;
  address: string;
  city?: string;
  state?: string;
  distance?: string;
}

interface PharmacyListProps {
  pharmacies: Pharmacy[];
  primaryColor: string;
  onPharmacySelect: (pharmacyName: string) => void;
  /** True on a past (non-latest) turn: render read-only. */
  disabled?: boolean;
}

const PharmacyList: React.FC<PharmacyListProps> = ({
  pharmacies,
  primaryColor,
  onPharmacySelect,
  disabled = false,
}) => {
  return (
    <Box sx={containerSx}>
      <Typography variant="body2" sx={titleSx}>
        Available Pharmacies:
      </Typography>
      <Typography variant="caption" sx={captionSx}>
        💡 Tip: Click a pharmacy below or use voice/text input (e.g., "Select CVS" or "Choose Walgreens")
      </Typography>
      <Box sx={getScrollBoxSx(primaryColor)}>
        {pharmacies.map((pharmacy) => (
          <Card
            key={pharmacy.id}
            onClick={disabled ? undefined : () => onPharmacySelect(pharmacy.name)}
            sx={{
              ...getPharmacyCardSx(primaryColor),
              ...(disabled && { cursor: "default", opacity: 0.5, pointerEvents: "none" }),
            }}
          >
            <Box sx={cardInnerBoxSx}>
              <LocalPharmacyIcon sx={getPharmacyIconSx(primaryColor)} />
              <Box sx={pharmacyTextBoxSx}>
                <Typography variant="body2" sx={pharmacyNameSx}>
                  {pharmacy.name} {pharmacy.distance && `(${pharmacy.distance})`}
                </Typography>
                {(() => {
                  const locationLine = [
                    pharmacy.address,
                    pharmacy.city,
                    pharmacy.state,
                  ]
                    .filter(Boolean)
                    .join(", ");
                  return locationLine ? (
                    <Typography variant="caption" sx={pharmacyAddressSx}>
                      {locationLine}
                    </Typography>
                  ) : null;
                })()}
              </Box>
            </Box>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default PharmacyList;

